import plants from './plants'
import fashion from './fashion'
import food from './food'
const templates = [
    plants,
    fashion,
    food,
];
export default templates